import { Controller } from '@hotwired/stimulus'
import { Sourdough, toast } from 'sourdough-toast'

export default class extends Controller {
  static targets = ['message']

  initialize () {
    const sourdough = new Sourdough({
      maxToasts: 10,
      duration: 5000,
      width: 356,
      gap: 14,
      theme: 'light',
      viewportOffset: 32,
      expandedByDefault: false,
      yPosition: 'bottom',
      xPosition: 'center',
      richColors: true,
      closeButton: true
    })

    sourdough.boot()

    window.toast = toast
  }

  showToast ({ params: { settings } }) {
    toast.message(settings)
  }

  messageTargetConnected (element) {
    const settings = JSON.parse(element.dataset.toastSettingsParam)
    toast.message(settings)
  }
}
